import { useGaugeState } from "@mui/x-charts"

interface MuiGaugePointerProps {
  actualValue: number
  domainMin: number
  domainMax: number
  startAngleRad: number
  endAngleRad: number
}

const MuiGaugePointer = ({
  actualValue,
  domainMin,
  domainMax,
  startAngleRad,
  endAngleRad,
}: MuiGaugePointerProps) => {
  const { innerRadius, outerRadius, cx, cy } = useGaugeState()

  const ratio =
    domainMax > domainMin ? (actualValue - domainMin) / (domainMax - domainMin) : 0
  const angle = startAngleRad + ratio * (endAngleRad - startAngleRad)

  const meanRadius = (innerRadius + outerRadius) / 2
  const dotRadius = (outerRadius - innerRadius) / 9
  const x = cx + meanRadius * Math.sin(angle)
  const y = cy - meanRadius * Math.cos(angle)

  return <circle cx={x} cy={y} r={dotRadius} fill="#ffffff" />
}

export default MuiGaugePointer
